import { all } from 'redux-saga/effects';
import repositorySaga from './repository';

export default function* repositoryModuleSaga() {
  yield all([repositorySaga()]);
}
